import { Context, type Cause, type Effect, Layer, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { KVClipboardFailure, KVClipboardSnapshot } from "./clipboard-model.ts";

export class KVClipboardIo extends Context.Service<KVClipboardIo, {
  readonly writeText: (text: string) => Effect.Effect<unknown, KVClipboardFailure>;
}>()("workerstation/frontend/KVClipboardIo") {}
export const KVClipboardIoTest = (io: typeof KVClipboardIo.Service) => Layer.succeed(KVClipboardIo, io);
export interface KVClipboardSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<KVClipboardSnapshot>>;
  readonly read: Effect.Effect<KVClipboardSnapshot>;
  readonly copy: Effect.Effect<void>;
}
export class KVClipboards extends Context.Service<KVClipboards, {
  readonly open: (text: string) => Effect.Effect<KVClipboardSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<KVClipboardFailure>[]>;
}>()("workerstation/frontend/KVClipboards") {}
